import navigate from '~/mixins/navigate'

export default {
  mixins: [navigate],

  props: {
    type: {
      type: String,
      default: 'primary',
      validator: prop =>
        ['primary', 'secondary', 'tertiary', 'menu', 'wide', 'megamenu', 'modal', 'custom'].includes(prop),
    },

    navigateOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    typeClasses() {
      return `link--${this.type}`
    },
  },
}
